import { render, staticRenderFns } from "./approach.vue?vue&type=template&id=dd761036&scoped=true"
import script from "./approach.vue?vue&type=script&lang=js"
export * from "./approach.vue?vue&type=script&lang=js"
import style0 from "./approach.vue?vue&type=style&index=0&id=dd761036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd761036",
  null
  
)

export default component.exports